import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import productData from '../../data/products.json';
import { useCart } from '../../context/CartContext';
import RequestQuoteModal from './RequestQuoteModal';

function Toast({ message, show }) {
    if (!show) return null;
    return (
        <div style={{position:'fixed',bottom:32,left:'50%',transform:'translateX(-50%)',background:'#222',color:'#fff',padding:'12px 32px',borderRadius:8,zIndex:9999,boxShadow:'0 2px 8px rgba(0,0,0,0.15)'}}>
            {message}
        </div>
    );
}

export default function ProductDetailPage() {
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ name: '', email: '', phone: '', quantity: 1, address: '', country: '', message: '' });
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [isMounted, setIsMounted] = useState(false);

    React.useEffect(() => {
        setIsMounted(true);
    }, []);

    // Prevent background scroll when modal is open
    React.useEffect(() => {
        if (showModal) {
            // Apply to both html and body for cross-browser compatibility
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
        } else {
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
        }
        
        return () => {
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
        };
    }, [showModal]);


    const handleInputChange = (e) => {
        const { name, value, type } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'number' ? parseInt(value, 10) || '' : value
        }));
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        setFormSubmitted(true);
        setShowModal(false);
        // You can replace this alert with an API call
        alert(`Sample request submitted!\nName: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\nQuantity: ${formData.quantity}\nAddress: ${formData.address}\nCountry: ${formData.country}\nMessage: ${formData.message}`);
        setFormData({ name: '', email: '', phone: '', quantity: 1, address: '', country: '', message: '' });
        setTimeout(() => setFormSubmitted(false), 2000);
    };

    const { categoryId, productId } = useParams();
    const [quantity, setQuantity] = useState(1);
    const { addToCart } = useCart();
    const [toast, setToast] = useState(false);
    
    const product = productData.products.find(p => p.id === productId);

    if (!product) {
        return (
            <div className="container mx-auto px-4 py-8">
                <h2 className="text-3xl font-bold text-center mb-8">Product not found</h2>
            </div>
        );
    }

    const handleQuantityChange = (change) => {
        const newQuantity = quantity + change;
        if (newQuantity >= 1) {
            setQuantity(newQuantity);
        }
    };

    return (
        <>
            <Toast message="Added to Enquiry Cart!" show={toast} />
            <div className="container mx-auto px-4 py-8">
                <div className="flex flex-col md:flex-row">
                    {/* Product Image */}
                    <div className="md:w-1/2 mb-6 md:mb-0">
                        <img
    className="rounded-7xl"
    src={product.image}
    alt={product.name}
/>
                    </div>
                    {/* Product Details */}
                    <div className="md:w-1/2 md:pl-8">
                        <h4 className="mb-4 text-lg md:text-2xl leading-tight text-darkCoolGray-900 font-bold tracking-tighter">
                            {product.name}
                        </h4>
                        <p className="mb-2 text-base text-coolGray-500">SKU/Code: {product.sku}</p>
                        {/* Quantity Selector */}
                        <div className="flex items-center mb-4">
                            <div className="flex items-center border border-coolGray-200 rounded-lg">
                                <button 
                                    onClick={() => handleQuantityChange(-1)}
                                    className="py-2 px-4 text-coolGray-500 hover:bg-gray-100 rounded-l-lg"
                                >
                                    -
                                </button>
                                <span className="py-2 px-4">{quantity}</span>
                                <button 
                                    onClick={() => handleQuantityChange(1)}
                                    className="py-2 px-4 text-coolGray-500 hover:bg-gray-100 rounded-r-lg"
                                >
                                    +
                                </button>
                            </div>
                        </div>
                        {/* Action Buttons */}
                        <div className="flex flex-col sm:flex-row gap-3 mb-6">
                            <button
    className="inline-block py-3 px-7 w-full md:w-auto text-lg leading-7 text-green-50 bg-green-500 hover:bg-green-600 font-medium text-center focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 border border-transparent rounded-md shadow-sm"
    type="button"
    onClick={() => {
        addToCart({
            id: product.id,
            name: product.name,
            quantity,
            sku: product.sku,
            image: product.image
        });
        setToast(true);
        setTimeout(() => setToast(false), 2000);
    }}
>
    Add to Enquiry Cart
</button>
<button
    type="button"
    className="inline-block py-3 px-7 w-full md:w-auto text-lg leading-7 text-green-50 bg-green-500 hover:bg-green-600 font-medium text-center focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 border border-transparent rounded-md shadow-sm"
    onClick={() => setShowModal(true)}
>
    Sample Request
</button>
                        </div>
                        {/* Description */}
                        <div className="mb-6">
                            <h5 className="mb-4 text-base md:text-xl leading-tight text-darkCoolGray-900 font-bold tracking-tighter">
                                Description
                            </h5>
                            <ul className="space-y-2 text-coolGray-500">
                                {product.description.map((item, index) => (
                                    <li key={index} className="flex items-start">
                                        <span className="mr-2">•</span>
                                        <p className="text-lg md:text-xl text-coolGray-500 font-medium">{item}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {/* Modal for Sample Request */}
            <RequestQuoteModal 
                isOpen={showModal && isMounted} 
                onClose={() => setShowModal(false)}
                formData={formData}
                handleInputChange={handleInputChange}
                handleFormSubmit={handleFormSubmit}
                productName={product.name}
            />
        </>
    );
}
